import './tokens.css';
import c from './Landing.module.css';
import { Contact } from './Contact';
import { Footer } from './Footer';
import { Hero } from './Hero';
import { Marquee } from './Marquee';
import { Nav } from './Nav';
import { Platform } from './Platform';
import { Products } from './Products';
import { Toolkit } from './Toolkit';

// Consulting-first order: proof of work before the capability list.
export function Landing() {
  return (
    <div id="top" className={c.page}>
      <div className={c.glow} />
      <div className={c.gridLines} />
      <Nav />
      <Hero />
      <Marquee />
      <Products />
      <Platform />
      <Toolkit />
      <Contact />
      <Footer />
    </div>
  );
}
